import { render, staticRenderFns } from "./HistorialVersionesReporte.vue?vue&type=template&id=50f8991a&scoped=true"
import script from "./HistorialVersionesReporte.vue?vue&type=script&lang=js"
export * from "./HistorialVersionesReporte.vue?vue&type=script&lang=js"
import style0 from "./HistorialVersionesReporte.vue?vue&type=style&index=0&id=50f8991a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f8991a",
  null
  
)

export default component.exports